@if (ppShow) {
  <div
    class="dropdown filterDropdown"
    [ngClass]="cssClasses"
    [ngStyle]="{ 'min-width': ppMinWidth }"
  >
    <ng-content></ng-content>
  </div>
}
